export const MASKED_FIELD_DISPLAY = '••••••••';

const MASKABLE_FIELD_TYPES = new Set([
  'text',
  'textarea',
  'richtext',
  'url',
  'email',
  'phone',
]);

export function parseFieldConfig(fieldOrConfig) {
  const raw =
    fieldOrConfig?.config ??
    fieldOrConfig?.fieldConfig ??
    (fieldOrConfig && typeof fieldOrConfig === 'object' && !Array.isArray(fieldOrConfig) && fieldOrConfig.mask_value != null
      ? fieldOrConfig
      : null);

  if (!raw) return {};

  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }

  if (typeof raw === 'object' && !Array.isArray(raw)) {
    return raw;
  }

  return {};
}

export function canEnableFieldMasking(dataType) {
  return MASKABLE_FIELD_TYPES.has(String(dataType || '').toLowerCase());
}

export function isFieldValueMasked(field) {
  if (!field) return false;
  const type = String(field.type || field.data_type || field.dataType || '').toLowerCase();
  if (type === 'password') return true;
  const cfg = parseFieldConfig(field);
  return cfg.mask_value === true || cfg.maskValue === true;
}

export function getMaskedFieldDisplay(hasValue = true) {
  return hasValue ? MASKED_FIELD_DISPLAY : '';
}

export function resolveMaskedFieldDisplay(field, rawValue) {
  if (!isFieldValueMasked(field)) return null;
  const hasValue = rawValue != null && rawValue !== '';
  if (!hasValue) return null;
  return MASKED_FIELD_DISPLAY;
}

export function buildFieldConfigPayload(dataType, config = {}) {
  if (!canEnableFieldMasking(dataType)) {
    return null;
  }
  const parsed = parseFieldConfig(config);
  return {
    mask_value: parsed.mask_value === true || parsed.maskValue === true,
  };
}

export function getMaskedReportCellDisplay(field, fieldData) {
  if (!isFieldValueMasked(field)) return null;
  const value =
    fieldData != null && typeof fieldData === 'object'
      ? fieldData.value
      : fieldData;
  if (value == null || value === '') return '';
  return MASKED_FIELD_DISPLAY;
}
